// extracted by mini-css-extract-plugin
export default {"wrapper":"bu7Zyf","spacer":"GbR49k","quantity":"hAaxKw","button":"AbtWGM"};